/* tslint:disable */
/* eslint-disable */

/**
 * 0 = StandardProducts
 * 
 * 1 = CustomProducts
 * 
 * 2 = CableWorkingGear
 * 
 * 3 = Hire
 * 
 * 4 = MarineSales
 * 
 * 5 = Grapnels
 * 
 * 6 = NewLead
 * 
 * 7 = RepeatCustomProduct
 */
export enum DealCategory {
  StandardProducts = 0,
  CustomProducts = 1,
  CableWorkingGear = 2,
  Hire = 3,
  MarineSales = 4,
  Grapnels = 5,
  NewLead = 6,
  RepeatCustomProduct = 7
}
